import {createResourceTableUpdatedReducer} from '../../../helpers/models/resourceHelpers';
import {SchedulingLinkModel} from '../../../models/api/schedulingLinkModel';
import {AppAction} from '../../appActions';
import {deleteFromResourceTable, ResourceTable} from '../../appTypes';
import {DataGroupsActionsEnum} from '../dataGroupsActions';
import {SchedulingLinkActionsEnum} from './schedulingLinksActions';

/*
 * Reducer.
 */

const schedulingLinksUpdatedReducer = createResourceTableUpdatedReducer(
  'schedulingLinks',
  (schedulingLink) => schedulingLink.id,
);

export function schedulingLinksReducer(
  state: ResourceTable<number, SchedulingLinkModel>,
  action: AppAction,
): ResourceTable<number, SchedulingLinkModel> {
  switch (action.type) {
    case DataGroupsActionsEnum.DATA_UPDATED:
      return schedulingLinksUpdatedReducer(state, action);

    case SchedulingLinkActionsEnum.SCHEDULING_LINK_UPDATED:
      return schedulingLinksUpdatedReducer(state, {
        ...action,
        payload: {
          result: {
            schedulingLinks: [action.payload],
          },
        },
      });

    case SchedulingLinkActionsEnum.SCHEDULING_LINK_DELETED:
      return deleteFromResourceTable(state, action.payload);

    default:
      return state;
  }
}
